export { default } from './SimilarInventory'
